export const isProductionEnv = import.meta.env.TOURPWA_ENVIRONMENT === 'production';
